const state = [
  ["CA", "AB", "Alberta", 55.001251, -115.002136],
  ["CA", "BC", "British Columbia", 55.001251, -125.002441],
  ["CA", "MB", "Manitoba", 55.001251, -97.001038],
  ["CA", "NB", "New Brunswick", 46.500283, -66.750183],
  ["CA", "NL", "Newfoundland and Labrador", 53.8217327, -61.2295532],
  ["CA", "NT", "Northwest Territories", 65.0000004, -118],
  ["CA", "NS", "Nova Scotia", 45.1960403, -63.1653789],
  ["CA", "NU", "Nunavut", 65.0377727, -92.5540791],
  ["CA", "ON", "Ontario", 50.000678, -86.000977],
  ["CA", "PE", "Prince Edward Island", 46.5035454, -63.5955171],
  ["CA", "QC", "Quebec", 52.4760892, -71.8258668],
  ["CA", "SK", "Saskatchewan", 55.5321257, -106.1412243],
  ["CA", "YT", "Yukon", 64.282326, -135],
  ["CN", "AH", "Anhui", 31.91667, 117.16667],
  ["CN", "BJ", "Beijing", 39.906217, 116.3912757],
  ["CN", "CQ", "Chongqing", 29.5585712, 106.5492822],
  ["CN", "FJ", "Fujian", 26.5450001, 117.842778],
  ["CN", "GS", "Gansu", 38.0000001, 101.9999999],
  ["CN", "GD", "Guangdong", 23.1357694, 113.1982688],
  ["CN", "GX", "Guangxi Zhuang Autonomous Region", 24.015869, 120.500481],
  ["CN", "GZ", "Guizhou", 27, 107],
  ["CN", "HI", "Hainan", 19.2000001, 109.5999999],
  ["CN", "HE", "Hebei", 39.0000001, 116],
  ["CN", "HL", "Heilongjiang", 48.0000047, 127.999992],
  ["CN", "HA", "Henan", 34.0000001, 113.9999999],
  ["CN", "HK", "Hong Kong", 22.350627, 114.1849161],
  ["CN", "HB", "Hubei", 31.1517252, 112.8783222],
  ["CN", "HN", "Hunan", 27.6662087, 111.7487063],
  ["CN", "NM", "Inner Mongolia", 43.5, 114.75],
  ["CN", "JS", "Jiangsu", 33.0000001, 119.9999999],
  ["CN", "JX", "Jiangxi", 28, 116],
  ["CN", "JL", "Jilin", 42.9995032, 125.9816054],
  ["CN", "TW-KEE", "Keelung", 36.0669718, 120.4109064],
  ["CN", "LN", "Liaoning", 40.9433143, 122.2622541],
  ["CN", "MO", "Macau", 22.20056, 113.54611],
  ["CN", "NX", "Ningxia Hui Autonomous Region", 37.0000001, 105.9999999],
  ["CN", "QH", "Qinghai", 36, 96],
  ["CN", "SN", "Shaanxi", 36, 109],
  ["CN", "SD", "Shandong", 36.0000001, 118.9999999],
  ["CN", "SH", "Shanghai", 31.2252985, 121.4890497],
  ["CN", "SX", "Shanxi", 37, 112],
  ["CN", "SC", "Sichuan", 30.5, 102.66667],
  [
    "CN",
    "TW",
    "Taiwan Province, People's Republic of China",
    23.697809,
    120.960518
  ],
  ["CN", "XZ", "Tibet Autonomous Region", 29.8556443, 90.8749807],
  ["CN", "XJ", "Xinjiang", 42.4804953, 85.4633464],
  ["CN", "YN", "Yunnan", 25, 101.5],
  ["CN", "ZJ", "Zhejiang", 29.0000001, 119.9999999],
  ["FR", "WF-AL", "Alo", -14.31096, -178.11094],
  ["FR", "A", "Alsace", 48.2491765, 7.40747],
  ["FR", "B", "Aquitaine", 43.8413157, 4.3662164],
  ["FR", "C", "Auvergne", 45.7100132, 3.1531803],
  ["FR", "ARA", "Auvergne-Rhône-Alpes", 45.2968119, 4.6604809],
  ["FR", "BFC", "Bourgogne-Franche-Comté", 46.7369092, 4.8501834],
  ["FR", "BRE", "Brittany", 48.1628283, -2.6841473],
  ["FR", "D", "Burgundy", 47.25, 4.16667],
  ["FR", "CVL", "Centre-Val de Loire", 47.5490251, 1.7324062],
  ["FR", "G", "Champagne-Ardenne", 48.873066, 4.20791],
  ["FR", "COR", "Corsica", 42.1880897, 9.0684138],
  ["FR", "I", "Franche-Comté", 47.1425847, 6.1320222],
  ["FR", "GF", "French Guiana", 4.0039882, -52.999998],
  ["FR", "PF", "French Polynesia", -16.0344249, -146.0490931],
  ["FR", "GES", "Grand Est", 48.4845157, 6.113035],
  ["FR", "GP", "Guadeloupe", 16.2490067, -61.5650444],
  ["FR", "HDF", "Hauts-de-France", 50.1024606, 2.7247515],
  ["FR", "IDF", "Île-de-France", 48.6443057, 2.7537863],
  ["FR", "K", "Languedoc-Roussillon", 43.654203, 3.6746699],
  ["FR", "L", "Limousin", 43.7029358, -1.0592415],
  ["FR", "M", "Lorraine", 49.60083, 5.0921632],
  ["FR", "P", "Lower Normandy", 48.9536845, -0.5733654],
  ["FR", "MQ", "Martinique", 14.6367927, -61.0158269],
  ["FR", "YT", "Mayotte", -12.823048, 45.1520755],
  ["FR", "O", "Nord-Pas-de-Calais", 50.5289691, 2.4545149],
  ["FR", "NOR", "Normandy", 49.4405918, 1.0889346],
  ["FR", "NAQ", "Nouvelle-Aquitaine", 45.4039367, 0.3756199],
  ["FR", "OCC", "Occitania", 43.6487851, 2.3435684],
  ["FR", "75", "Paris", 48.8566969, 2.3514616],
  ["FR", "PDL", "Pays de la Loire", 47.6594864, -0.8186143],
  ["FR", "S", "Picardy", 50.9585459, 1.8553191],
  ["FR", "T", "Poitou-Charentes", 43.7029358, -1.0592415],
  ["FR", "PAC", "Provence-Alpes-Côte d'Azur", 44.0580563, 6.0638506],
  ["FR", "RE", "Réunion", -21.130738, 55.5364801],
  ["FR", "V", "Rhône-Alpes", 45.3175313, 5.7212944],
  ["FR", "BL", "Saint Barthélemy", 17.9036287, -62.8115688],
  ["FR", "MF", "Saint Martin", 48.5683066, 6.7539988],
  ["FR", "PM", "Saint Pierre and Miquelon", 46.7832469, -56.1951589],
  ["FR", "WF-SG", "Sigave", -14.2743367, -178.1545573],
  ["FR", "Q", "Upper Normandy", 49.3711269, 1.026055],
  ["FR", "WF-UV", "Uvea", -14.301905, -178.0899734],
  ["FR", "WF", "Wallis and Futuna", -14.301905, -178.0899734],
  ["DE", "BW", "Baden-Württemberg", 48.6296972, 9.1949534],
  ["DE", "BY", "Bavaria", 48.9467562, 11.4038717],
  ["DE", "BE", "Berlin", 52.5170365, 13.3888599],
  ["DE", "BB", "Brandenburg", 52.8455492, 13.2461296],
  ["DE", "HB", "Bremen", 53.0758196, 8.8071646],
  ["DE", "HH", "Hamburg", 53.550341, 10.000654],
  ["DE", "HE", "Hesse", 50.6118537, 9.1909725],
  ["DE", "NI", "Lower Saxony", 52.8398531, 9.075962],
  ["DE", "MV", "Mecklenburg-Vorpommern", 53.7735234, 12.5755746],
  ["DE", "LA", "Neufahrn in Niederbayern", 48.7364422, 12.1925349],
  ["DE", "NW", "North Rhine-Westphalia", 51.4781796, 7.5542336],
  ["DE", "RP", "Rhineland-Palatinate", 49.9531599, 7.310646],
  ["DE", "SL", "Saarland", 49.4173988, 6.9805789],
  ["DE", "SN", "Saxony", 50.9295798, 13.4585052],
  ["DE", "ST", "Saxony-Anhalt", 51.908526, 11.4939134],
  ["DE", "SH", "Schleswig-Holstein", 54.1853998, 9.8220089],
  ["DE", "TH", "Thuringia", 50.7333163, 11.0747905],
  ["JP", "23", "Aichi Prefecture", 34.8527483, 137.3851649],
  ["JP", "5", "Akita Prefecture", 39.7197629, 140.1034669],
  ["JP", "2", "Aomori Prefecture", 40.886943, 140.590121],
  ["JP", "12", "Chiba Prefecture", 35.549399, 140.2647303],
  ["JP", "38", "Ehime Prefecture", 33.6013646, 132.8185275],
  ["JP", "18", "Fukui Prefecture", 36.061751, 136.2260542],
  ["JP", "40", "Fukuoka Prefecture", 33.5898988, 130.4017509],
  ["JP", "7", "Fukushima Prefecture", 37.3662591, 140.2511854],
  ["JP", "21", "Gifu Prefecture", 35.7867449, 137.0460777],
  ["JP", "10", "Gunma Prefecture", 36.3909955, 139.0634676],
  ["JP", "34", "Hiroshima Prefecture", 34.5666725, 132.753565],
  ["JP", "1", "Hokkaidō Prefecture", 43.4339535, 142.9514468],
  ["JP", "28", "Hyōgo Prefecture", 34.914934, 134.860666],
  ["JP", "8", "Ibaraki Prefecture", 36.2869536, 140.4703384],
  ["JP", "17", "Ishikawa Prefecture", 36.9888678, 136.8163563],
  ["JP", "3", "Iwate Prefecture", 39.9724169, 141.2124422],
  ["JP", "37", "Kagawa Prefecture", 35.3562043, 139.3999184],
  ["JP", "46", "Kagoshima Prefecture", 31.521587, 130.5474077],
  ["JP", "14", "Kanagawa Prefecture", 35.4342935, 139.374753],
  ["JP", "43", "Kumamoto Prefecture", 32.6450475, 130.6341345],
  ["JP", "26", "Kyōto Prefecture", 35.242552, 135.454601],
  ["JP", "24", "Mie Prefecture", 34.7339685, 136.5154489],
  ["JP", "4", "Miyagi Prefecture", 34.9803071, 139.838919],
  ["JP", "45", "Miyazaki Prefecture", 32.097681, 131.294542],
  ["JP", "20", "Nagano Prefecture", 36.648327, 138.1342028],
  ["JP", "42", "Nagasaki Prefecture", 33.1154683, 129.7874339],
  ["JP", "29", "Nara Prefecture", 34.6845445, 135.8048359],
  ["JP", "15", "Niigata Prefecture", 37.6452283, 138.7669125],
  ["JP", "44", "Ōita Prefecture", 33.1819875, 131.4270217],
  ["JP", "33", "Okayama Prefecture", 34.8581334, 133.7759256],
  ["JP", "47", "Okinawa Prefecture", 26.5707754, 128.0255901],
  ["JP", "27", "Ōsaka Prefecture", 34.6198813, 135.490357],
  ["JP", "41", "Saga Prefecture", 33.2185408, 130.1296585],
  ["JP", "11", "Saitama Prefecture", 35.9907007, 139.6354],
  ["JP", "25", "Shiga Prefecture", 35.247154, 136.109385],
  ["JP", "32", "Shimane Prefecture", 34.9418212, 132.537439],
  ["JP", "22", "Shizuoka Prefecture", 34.979149, 138.38299],
  ["JP", "9", "Tochigi Prefecture", 36.6782167, 139.8096549],
  ["JP", "36", "Tokushima Prefecture", 33.9196418, 134.2509634],
  ["JP", "13", "Tokyo", 36.3910543, 139.063453],
  ["JP", "31", "Tottori Prefecture", 35.3555075, 133.8678525],
  ["JP", "16", "Toyama Prefecture", 36.6468015, 137.2183531],
  ["JP", "30", "Wakayama Prefecture", 33.8070292, 135.5930743],
  ["JP", "6", "Yamagata Prefecture", 38.4746705, 140.083237],
  ["JP", "35", "Yamaguchi Prefecture", 34.2379614, 131.5873845],
  ["JP", "19", "Yamanashi Prefecture", 35.6399328, 138.6380495],
  ["KR", "26", "Busan", 35.1799528, 129.0752365],
  ["KR", "27", "Daegu", 35.8713, 128.6018],
  ["KR", "30", "Daejeon", 36.3496, 127.3848],
  ["KR", "42", "Gangwon Province", 37.885, 127.7297],
  ["KR", "29", "Gwangju", 35.1595775, 126.8515089],
  ["KR", "41", "Gyeonggi Province", 37.2752, 127.0095],
  ["KR", "28", "Incheon", 37.456, 126.7052],
  ["KR", "49", "Jeju", 33.3939924, 126.5626653],
  ["KR", "43", "North Chungcheong Province", 36.6357, 127.4915],
  ["KR", "47", "North Gyeongsang Province", 36.5754, 128.5058],
  ["KR", "45", "North Jeolla Province", 35.8198999, 127.109],
  ["KR", "50", "Sejong City", 36.4799999, 127.289],
  ["KR", "11", "Seoul", 37.5666791, 126.9782914],
  ["KR", "44", "South Chungcheong Province", 36.6593, 126.6729],
  ["KR", "48", "South Gyeongsang Province", 35.2382, 128.6925],
  ["KR", "46", "South Jeolla Province", 34.8159, 126.4629],
  ["KR", "31", "Ulsan", 35.5391697, 129.3119136],
  ["TH", "37", "Amnat Charoen", 15.8620327, 104.6327143],
  ["TH", "15", "Ang Thong", 14.6495224, 100.3170382],
  ["TH", "10", "Bangkok", 13.7542529, 100.493087],
  ["TH", "38", "Bueng Kan", 18.366023, 103.650515],
  ["TH", "31", "Buri Ram", 14.9955693, 103.1079187],
  ["TH", "24", "Chachoengsao", 13.6093192, 101.5467201],
  ["TH", "18", "Chai Nat", 15.1846204, 100.1278743],
  ["TH", "22", "Chanthaburi", 12.9081033, 102.0159145],
  ["TH", "50", "Chiang Mai", 18.790876, 98.988048],
  ["TH", "57", "Chiang Rai", 19.7589517, 99.6734592],
  ["TH", "20", "Chon Buri", 12.9546988, 100.7746464],
  ["TH", "86", "Chumphon", 10.3782724, 99.0077685],
  ["TH", "46", "Kalasin", 16.4320082, 103.506929],
  ["TH", "62", "Kamphaeng Phet", 16.4739502, 99.525984],
  ["TH", "71", "Kanchanaburi", 14.44019, 99.2676727],
  ["TH", "40", "Khon Kaen", 16.6022387, 102.6352933],
  ["TH", "81", "Krabi", 8.1111653, 99.1097298],
  ["TH", "52", "Lampang", 18.6799728, 99.7332501],
  ["TH", "51", "Lamphun", 18.2661422, 98.96749],
  ["TH", "42", "Loei", 17.3158563, 101.4638277],
  ["TH", "16", "Lopburi", 15.026458, 100.8089178],
  ["TH", "58", "Mae Hong Son", 19.3007277, 97.9649168],
  ["TH", "44", "Maha Sarakham", 16.1861887, 103.2955401],
  ["TH", "49", "Mukdahan", 16.6972385, 104.3470293],
  ["TH", "26", "Nakhon Nayok", 14.203647, 101.2147087],
  ["TH", "73", "Nakhon Pathom", 13.8918425, 100.0165659],
  ["TH", "48", "Nakhon Phanom", 17.3952209, 104.7880321],
  ["TH", "30", "Nakhon Ratchasima", 15.2241917, 101.9313754],
  ["TH", "60", "Nakhon Sawan", 15.697411, 100.1254381],
  ["TH", "80", "Nakhon Si Thammarat", 8.4321444, 99.9638643],
  ["TH", "55", "Nan", 18.7544594, 100.624804],
  ["TH", "96", "Narathiwat", 6.4277319, 101.8212475],
  ["TH", "39", "Nong Bua Lam Phu", 17.2017817, 102.4404314],
  ["TH", "43", "Nong Khai", 17.8812453, 102.7490052],
  ["TH", "12", "Nonthaburi", 13.8623206, 100.5144841],
  ["TH", "13", "Pathum Thani", 14.0165371, 100.5321597],
  ["TH", "94", "Pattani", 6.8678652, 101.2504538],
  ["TH", "S", "Pattaya", 12.931941, 100.9009534],
  ["TH", "82", "Phang Nga", 8.5058295, 98.5680335],
  ["TH", "93", "Phatthalung", 7.6188786, 100.0822175],
  ["TH", "56", "Phayao", 19.1666313, 99.9019423],
  ["TH", "67", "Phetchabun", 16.4165039, 101.1595234],
  ["TH", "76", "Phetchaburi", 13.0692869, 99.6044376],
  ["TH", "66", "Phichit", 16.4421088, 100.3430289],
  ["TH", "65", "Phitsanulok", 16.8162447, 100.2638874],
  ["TH", "14", "Phra Nakhon Si Ayutthaya", 14.3535427, 100.5645684],
  ["TH", "54", "Phrae", 18.2930601, 100.0886757],
  ["TH", "83", "Phuket", 7.9366015, 98.3529292],
  ["TH", "25", "Prachin Buri", 14.0549259, 101.3713628],
  ["TH", "77", "Prachuap Khiri Khan", 12.0432669, 99.7487235],
  ["TH", "85", "Ranong", 10.0469546, 98.6870133],
  ["TH", "70", "Ratchaburi", 13.6317897, 99.3558216],
  ["TH", "21", "Rayong", 12.6817905, 101.277765],
  ["TH", "45", "Roi Et", 16.056247, 103.653095],
  ["TH", "27", "Sa Kaeo", 13.7686129, 102.1345352],
  ["TH", "47", "Sakon Nakhon", 17.1660016, 104.1519383],
  ["TH", "11", "Samut Prakan", 13.5964801, 100.5997041],
  ["TH", "74", "Samut Sakhon", 13.5708192, 100.2585874],
  ["TH", "75", "Samut Songkhram", 13.3576862, 99.9619685],
  ["TH", "19", "Saraburi", 14.5249471, 100.9160757],
  ["TH", "91", "Satun", 7.0366682, 99.9615397],
  ["TH", "33", "Si Sa Ket", 15.116794, 104.332348],
  ["TH", "17", "Sing Buri", 14.9936716, 100.3602963],
  ["TH", "90", "Songkhla", 6.8790221, 100.5498542],
  ["TH", "64", "Sukhothai", 17.0126541, 99.8150671],
  ["TH", "72", "Suphanburi", 14.6777, 100.0350785],
  ["TH", "84", "Surat Thani", 9.1415643, 99.329055],
  ["TH", "32", "Surin", 14.884901, 103.493048],
  ["TH", "63", "Tak", 17.1053568, 98.9953943],
  ["TH", "92", "Trang", 7.5607389, 99.6114944],
  ["TH", "23", "Trat", 12.2593544, 102.4268871],
  ["TH", "34", "Ubon Ratchathani", 15.226428, 104.8581711],
  ["TH", "41", "Udon Thani", 17.5211917, 102.6680012],
  ["TH", "61", "Uthai Thani", 15.3912084, 99.4560531],
  ["TH", "53", "Uttaradit", 17.6242525, 100.0937279],
  ["TH", "95", "Yala", 6.3344846, 101.1409694],
  ["TH", "35", "Yasothon", 16.0282186, 104.2748479],
  ["US", "AL", "Alabama", 33.2588817, -86.8295337],
  ["US", "AK", "Alaska", 64.4459613, -149.680909],
  ["US", "AS", "American Samoa", -14.300631, -170.6959748],
  ["US", "AZ", "Arizona", 34.395342, -111.7632755],
  ["US", "AR", "Arkansas", 35.2048883, -92.4479108],
  ["US", "UM-81", "Baker Island", 0.1955757, -176.4778236],
  ["US", "CA", "California", 36.7014631, -118.7559974],
  ["US", "CO", "Colorado", 38.7251776, -105.6077167],
  ["US", "CT", "Connecticut", 41.6500201, -72.7342163],
  ["US", "DE", "Delaware", 38.6920451, -75.4013315],
  ["US", "DC", "District of Columbia", 38.8936613, -76.9878833],
  ["US", "FL", "Florida", 27.7567667, -81.4639835],
  ["US", "GA", "Georgia", 32.3293809, -83.1137366],
  ["US", "GU", "Guam", 13.4501257, 144.757551],
  ["US", "HI", "Hawaii", 21.2160437, -157.975203],
  ["US", "UM-84", "Howland Island", 0.8075145, -176.61687],
  ["US", "ID", "Idaho", 43.6447642, -114.0154071],
  ["US", "IL", "Illinois", 40.0796606, -89.4337288],
  ["US", "IN", "Indiana", 40.3270127, -86.1746933],
  ["US", "IA", "Iowa", 41.9216734, -93.3122705],
  ["US", "UM-86", "Jarvis Island", -0.3722806, -159.9973612],
  ["US", "UM-67", "Johnston Atoll", 16.7524462, -169.5107016],
  ["US", "KS", "Kansas", 38.27312, -98.5821872],
  ["US", "KY", "Kentucky", 37.5726028, -85.1551411],
  ["US", "UM-89", "Kingman Reef", 6.4158187, -162.4386964],
  ["US", "LA", "Louisiana", 30.8703881, -92.007126],
  ["US", "ME", "Maine", 45.709097, -68.8590201],
  ["US", "MD", "Maryland", 39.5162234, -76.9382069],
  ["US", "MA", "Massachusetts", 42.3788774, -72.032366],
  ["US", "MI", "Michigan", 43.6211955, -84.6824346],
  ["US", "UM-71", "Midway Atoll", 28.2417536, -177.3754308],
  ["US", "MN", "Minnesota", 45.9896587, -94.6113288],
  ["US", "MS", "Mississippi", 32.9715645, -89.7348497],
  ["US", "MO", "Missouri", 38.7604815, -92.5617875],
  ["US", "MT", "Montana", 47.3752671, -109.6387579],
  ["US", "UM-76", "Navassa Island", 18.408351, -75.0144368],
  ["US", "NE", "Nebraska", 41.7370229, -99.5873816],
  ["US", "NV", "Nevada", 39.5158825, -116.8537227],
  ["US", "NH", "New Hampshire", 43.4849133, -71.6553992],
  ["US", "NJ", "New Jersey", 40.0757384, -74.4041622],
  ["US", "NM", "New Mexico", 34.5708167, -105.993007],
  ["US", "NY", "New York", 40.7127281, -74.0060152],
  ["US", "NC", "North Carolina", 35.6729639, -79.0392919],
  ["US", "ND", "North Dakota", 47.6201461, -100.540737],
  ["US", "MP", "Northern Mariana Islands", 14.1490205, 145.2134525],
  ["US", "OH", "Ohio", 40.2253569, -82.6881395],
  ["US", "OK", "Oklahoma", 34.9550817, -97.2684063],
  ["US", "OR", "Oregon", 43.9792797, -120.737257],
  ["US", "UM-95", "Palmyra Atoll", 5.882204, -162.0748745],
  ["US", "PA", "Pennsylvania", 40.9699889, -77.7278831],
  ["US", "PR", "Puerto Rico", 18.2214149, -66.4132818],
  ["US", "RI", "Rhode Island", 41.7962409, -71.5992372],
  ["US", "SC", "South Carolina", 33.6874388, -80.4363743],
  ["US", "SD", "South Dakota", 44.6471761, -100.348761],
  ["US", "TN", "Tennessee", 35.7730076, -86.2820081],
  ["US", "TX", "Texas", 31.8160381, -99.5120986],
  ["US", "UM", "United States Minor Outlying Islands", 30.369894, -97.532508],
  ["US", "VI", "United States Virgin Islands", 17.789187, -64.7080574],
  ["US", "UT", "Utah", 39.4225192, -111.7143584],
  ["US", "VT", "Vermont", 44.5990718, -72.5002608],
  ["US", "VA", "Virginia", 37.1232245, -78.4927721],
  ["US", "UM-79", "Wake Island", 19.2898893, 166.6492174],
  ["US", "WA", "Washington", 47.751076, -120.740135],
  ["US", "WV", "West Virginia", 38.4758406, -80.8408415],
  ["US", "WI", "Wisconsin", 44.4308975, -89.6884637],
  ["US", "WY", "Wyoming", 43.1700264, -107.5685348]
];

const stateOptions = state.reduce((acc, val) => {
  if (!acc[val[0]]) acc[val[0]] = [];
  acc[val[0]].push({ value: val[1], label: val[2], lat: val[3], lng: val[4] });
  return acc;
}, {});

export default stateOptions;
